'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = require('babel-helper-vue-jsx-merge-props');

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTablePlus',
  componentName: 'ElTablePlus',
  props: {
    currentChangeAsync: Function,
    columns: {
      type: Array,
      default: []
    },
    pageSize: {
      type: Number,
      default: 20
    },
    paginationAlign: {
      type: String,
      default: 'center',
      validator: function validator(value) {
        return ['left', 'right', 'center'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      data: [],
      loading: false,
      currentPage: 1,
      total: 0
    };
  },

  computed: {
    hasPagination: function hasPagination() {
      return !!this.currentChangeAsync;
    }
  },
  methods: {
    reload: function reload() {
      this.handleCurrentChange(1);
    },
    reloadCurrent: function reloadCurrent() {
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getData();
    },
    getData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _this = this;

        var _ref2, data, total;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.data = [];
                this.loading = true;
                _context.prev = 2;
                _context.next = 5;
                return this.currentChangeAsync(this.currentPage, this.pageSize);

              case 5:
                _ref2 = _context.sent;
                data = _ref2.data;
                total = _ref2.total;


                this.data = data;
                this.total = total;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](2);

                console.error(_context.t0); // eslint-disable-line

              case 15:
                this.$nextTick(function () {
                  _this.loading = false;
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function getData() {
        return _ref.apply(this, arguments);
      }

      return getData;
    }()
  },
  render: function render(h) {
    var namespace = 'el-table-plus';
    var _$slots = this.$slots,
        caption = _$slots.caption,
        actionBar = _$slots.actionBar,
        otherSlots = (0, _objectWithoutProperties3.default)(_$slots, ['caption', 'actionBar']);


    return h(
      'div',
      { 'class': namespace },
      [(caption || actionBar) && h(
        'div',
        { 'class': namespace + '__header' },
        [h(
          'h1',
          { 'class': namespace + '__header__caption' },
          [caption]
        ), h(
          'div',
          { 'class': namespace + '__header__action-bar' },
          [actionBar]
        )]
      ), h(
        'el-table',
        (0, _babelHelperVueJsxMergeProps2.default)([{
          attrs: { data: this.data },
          directives: [{
            name: 'loading',
            value: this.loading
          }]
        }, { props: this.$attrs, on: this.$listeners }]),
        [(0, _entries2.default)(otherSlots).map(function (_ref3) {
          var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
              key = _ref4[0],
              val = _ref4[1];

          return h(
            'template',
            { slot: key },
            [val]
          );
        }), this.columns.map(function (column) {
          var formatter = column.formatter,
              renderBody = column.renderBody;

          var data = {
            props: (0, _extends3.default)({}, column, {
              formatter: formatter && function (row) {
                return formatter(row[column.prop]);
              }
            })
          };

          if (renderBody) {
            data.scopedSlots = {
              default: function _default(_ref5) {
                var row = _ref5.row;

                return renderBody(h, row);
              }
            };
          }
          return h(
            'el-table-column',
            data,
            []
          );
        })]
      ), this.hasPagination && h(
        'el-pagination',
        { 'class': 'el-pagination--' + this.paginationAlign,
          attrs: { 'current-page': this.currentPage, 'page-size': this.pageSize,
            total: this.total,
            layout: 'total, prev, pager, next' },
          on: {
            'current-change': this.handleCurrentChange
          }
        },
        []
      )]
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/table-plus/src/table-plus.js
// module id = 305
// module chunks = 0